export default __webpack_public_path__ + "static/media/email.5e37706f.svg";